<script lang="ts">
  const {
    color = "#ff80ff",
    unit = "px",
    duration = "1s",
    size = "30",
    pause = false,
  }: {
    color?: string;
    unit?: string;
    duration?: string;
    size?: string | number;
    pause?: boolean;
  } = $props();
</script>

<div
  aria-hidden="true"
  class="circle"
  class:pause-animation={pause}
  style="--size: {size}{unit}; --color: {color}; --duration: {duration}"
></div>

<style>
  .circle {
    height: var(--size);
    width: var(--size);
    border-color: var(--color) transparent var(--color) var(--color);
    border-width: calc(var(--size) / 15);
    border-style: solid;
    border-image: initial;
    border-radius: 50%;
    animation: var(--duration) linear 0s infinite normal none running rotate;
  }
  .pause-animation {
    animation-play-state: paused;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
